<div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 80vh; gap: 20px;">
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- User circle -->
        <circle cx="60" cy="40" r="25" stroke="#DC2626" stroke-width="2" fill="#FEE2E2"/>
        <!-- User head -->
        <circle cx="60" cy="40" r="18" fill="#DC2626"/>
        
        <!-- User body -->
        <path d="M 35 70 Q 35 60 60 60 Q 85 60 85 70 L 85 95 Q 85 105 75 105 L 45 105 Q 35 105 35 95 Z" 
              fill="#DC2626"/>
        
        <!-- X mark (invalid) -->
        <line x1="75" y1="20" x2="95" y2="40" stroke="#DC2626" stroke-width="4" stroke-linecap="round"/>
        <line x1="95" y1="20" x2="75" y2="40" stroke="#DC2626" stroke-width="4" stroke-linecap="round"/>
    </svg>
    
    <div style="text-align: center;">
        <h2 style="color: #DC2626; margin: 0 0 10px 0; font-size: 24px;">Invalid User</h2>
        <p style="color: #6B7280; margin: 0; font-size: 16px;">Your profile is locked or inactive.</p>
        <p style="color: #9CA3AF; margin: 10px 0 0 0; font-size: 14px;">Please contact support for assistance.</p>
    </div>
</div>